import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// Client-side redirect handler.
// On every route change, ask the backend if `pathname` has a stored redirect.
// If yes, navigate to the new URL with `replace: true` so the old URL never
// appears in the browser history (matches 301 semantics as closely as SPA
// routing can). Skips admin, api, and auth routes.
//
// This complements the server-side prerendered HTML — Playwright's prerender
// also emits a `<meta http-equiv="refresh" content="0; url=...">` for stored
// redirects, so Googlebot sees the redirect immediately even without JS.
const SKIP_PREFIXES = ["/admin", "/api/", "/auth/callback", "/auth/google"];

export function RedirectGuard() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!pathname) return;
    if (SKIP_PREFIXES.some((p) => pathname.startsWith(p))) return;
    let cancelled = false;
    api
      .get("/redirects/lookup", { params: { path: pathname } })
      .then((r) => {
        if (cancelled) return;
        const to = r.data?.to;
        if (to && to !== pathname) {
          navigate(`${to}${search || ""}`, { replace: true });
        }
      })
      .catch(() => {
        // 404 → no redirect, standard case. Silently ignore.
      });
    return () => { cancelled = true; };
  }, [pathname, search, navigate]);

  return null;
}
